const HIDE_EVENT_TYPE = {
    CLICK: 'click',
    HOVER: 'hover',
};

let _enableClickHideEvent = true;
let _shownDropdownList = [];
let _bindEventType = '';
let _id = 0;

// 从已展示的列表中找到对应的dropdown的索引
const _findIndex = id => {
    return _shownDropdownList.findIndex(item => item.id === id);
};

// 关闭除了自身外，和自己等级一样或比自己等级高的面板
const _hideOtherDropdowns = (id, level) => {
    const hideList = _shownDropdownList.filter(item => {
        return item && item.id !== id && item.level >= level;
    });
    hideList.forEach(data => {
        if (!data) return;
        FJDropDownManager.hide(data, true);
    });
};

const _bindEvent = (eventType = HIDE_EVENT_TYPE.CLICK) => {
    if (_bindEventType && _bindEventType === eventType) return;
    // 当前存在绑定但是绑定的类型不同时，需要先解除之前的绑定
    if (_bindEventType && _bindEventType !== eventType) {
        _unbindEvent();
    }

    document.body.addEventListener('keydown', _onKeydown);
    const hideEvent = eventType === HIDE_EVENT_TYPE.CLICK ? 'mousedown' : 'mousemove';
    document.body.addEventListener(hideEvent, _onMouseDown);
    if (eventType === HIDE_EVENT_TYPE.CLICK) {
        // TODO 这里为什么还要监听root是由于一些未知的原因，响应被阻止掉了
        const root = document.getElementById('root');
        if (root) root.addEventListener(hideEvent, _onMouseDown);
    }
    _bindEventType = eventType;
};

const _unbindEvent = () => {
    if (!_bindEventType) return;
    document.body.removeEventListener('keydown', _onKeydown);
    const hideEvent = _bindEventType === HIDE_EVENT_TYPE.CLICK ? 'mousedown' : 'mousemove';
    document.body.removeEventListener(hideEvent, _onMouseDown);
    const root = document.getElementById('root');
    if (root) root.removeEventListener(hideEvent, _onMouseDown);
    _bindEventType = '';
};

// 根据触发条件自动绑定或解绑事件,获取最顶级的下拉组件的触发事件
const _autoBindEvent = () => {
    if (_shownDropdownList.length === 0) {
        _unbindEvent();
    } else {
        // 获取当前最高级别的下拉菜单数据，并重新绑定数据
        const topLevelData = _getTopLevelDropdownData();
        const trigger = topLevelData ? topLevelData.trigger : '';
        if (trigger) _bindEvent(trigger);
        else _unbindEvent();
    }
};

const _onKeydown = e => {
    if (e.key === 'Escape') {
        const data = _getTopLevelDropdownData();
        if (data) FJDropDownManager.hide(data);
    }
};

const _onMouseDown = e => {
    if (!_enableClickHideEvent) return;
    // 必须阻止冒泡，避免多余的响应
    e.stopPropagation();
    const data = _getTopLevelDropdownData();
    if (data) {
        const { checkCanBeHide } = data;
        if (!checkCanBeHide || checkCanBeHide(e)) {
            FJDropDownManager.hide(data);
        }
    }
};

// 获得已显示的最高等级的下拉菜单的数据
const _getTopLevelDropdownData = () => {
    let currentLevel = -1;
    let data;
    _shownDropdownList.forEach(item => {
        const { level } = item;
        if (level > currentLevel) {
            data = item;
            currentLevel = level;
        }
    });
    return data;
};

const FJDropDownManager = {
    createId: () => {
        ++_id;
        return _id;
    },
    // 如果在已显示的下拉菜单中存在和自身等级:
    // 1、关闭和自身等级一样或比自己高的的面板。
    // 2、将自身添加进显示列表中
    show: (data, ignoreOther = false) => {
        const { id, level, trigger = HIDE_EVENT_TYPE.CLICK, showFunction } = data;
        if (!ignoreOther) _hideOtherDropdowns(id, level);
        if (showFunction) showFunction();
        // 将下拉菜单的数据添加到列表中
        const index = _findIndex(id);
        if (index === -1) _shownDropdownList.push(data);

        _autoBindEvent();
    },
    // 将比自身等级大的面板关闭
    // 从显示的列表中删除
    hide: (data, ignoreOther = false) => {
        const { id, level, hideFunction } = data;
        if (!ignoreOther) _hideOtherDropdowns(id, level);
        if (hideFunction) hideFunction();
        // 从列表中删除
        const index = _findIndex(id);
        if (index !== -1) _shownDropdownList.splice(index, 1);

        _autoBindEvent();
    },

    hideOtherDropdowns: (id, level) => {
        _hideOtherDropdowns(id, level);
    },

    // 强制关闭所以有的下拉菜单
    hideAll: () => {
        const list = [..._shownDropdownList];
        _shownDropdownList = [];
        list.forEach(item => {
            if (!item || !item.hideFunction) return;
            item.hideFunction();
        });
        _unbindEvent();
    },
    // 关闭最顶级的dropdown
    hideTopLevelDropDown: () => {
        const data = _getTopLevelDropdownData();
        if (data) FJDropDownManager.hide(data);
    },
    /**
     * @desc 检查是否可响应关闭事件，只有当自己的面板等级是当前显示的下拉菜单中最高的等级才允许关闭
     * @param level - 下拉组件的等级
     * @return {boolean}
     */
    checkCanBeHide: level => {
        const isHigherThanMe = _shownDropdownList.find(item => item && item.level > level);
        return !isHigherThanMe;
    },
    setAllHideEventEnabled(value) {
        _enableClickHideEvent = value;
    },
};

export default FJDropDownManager;
